import { Injectable } from '@angular/core';
import { Encryptor } from './utils';

@Injectable({providedIn: 'any'})
export class StorageService {

  save(key: string, value: any): void {
    const jsonData = JSON.stringify(value);
    const encryptedData = Encryptor.encrypt(jsonData);
    localStorage.setItem(key, encryptedData);
  }

  get<T>(key: string): T | null {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;

    try {
      const decryptedData = Encryptor.decrypt(encryptedData);
      return JSON.parse(decryptedData) as T;
    } catch (error) {
      console.error('Error while decrypting or parsing data', error);
      return null;
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

}
